import { useQuery } from '@tanstack/react-query';
import { getCrashBounce } from '../lib/apiClient';

// The logger runs once an hour; no need to poll faster.
const STALE_TIME_MS = 5 * 60_000;

/** Forward paper test of Crash Bounce. Hypothetical only. */
export function useCrashBounce() {
  return useQuery({
    queryKey: ['crash-bounce'],
    queryFn: getCrashBounce,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
